import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

// The Syncfusion Word editor and its stylesheet are megabytes. Lazy so they enter
// the bundle only when someone actually opens the designer.
const TemplateDesignerScreen = lazy(() =>
  import('./pages/TemplateDesignerScreen').then((m) => ({ default: m.TemplateDesignerScreen })),
);

const designer = (
  <ProtectedRoute>
    <OnboardingCompletionGuard>
      <Suspense
        fallback={
          <div className="flex h-dvh items-center justify-center">
            <p className="text-sm text-gray66">Loading the template designer…</p>
          </div>
        }
      >
        <TemplateDesignerScreen />
      </Suspense>
    </OnboardingCompletionGuard>
  </ProtectedRoute>
);

// A template belongs to the tenant, but it is always reached from the workflow step
// that uses it — hence the workflow-scoped path. Without :templateId the designer
// starts a new template.
export const templatesRoutes = (
  <>
    <Route path="/workflows/:workflowId/template" element={designer} />
    <Route path="/workflows/:workflowId/template/:templateId" element={designer} />
  </>
);
